import { fromJS } from 'immutable';

import { createReducer } from '../utils/helpers';

import {
  FUNDING_DOCUMENT_UPLOAD_FAILURE,
  FUNDING_DOCUMENT_UPLOAD_PROGRESS,
  FUNDING_DOCUMENT_UPLOAD_START,
  FUNDING_DOCUMENT_UPLOAD_SUCCESS,
} from './types';

export * from './actions';

const initialState = fromJS({
  fundingDocuments: {
    /**
     * [identifier]: { success: bool, loading: bool, error: any, progress: number }
     */
  },
  documentData: {},
});

export default createReducer(initialState, {
  [FUNDING_DOCUMENT_UPLOAD_START]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingDocuments', action.identifier, 'loading'], true)
        .setIn(['fundingDocuments', action.identifier, 'progress'], 0),
    ),
  [FUNDING_DOCUMENT_UPLOAD_SUCCESS]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingDocuments', action.identifier, 'loading'], false)
        .setIn(['fundingDocuments', action.identifier, 'progress'], 0)
        .setIn(['fundingDocuments', action.identifier, 'success'], true)
        .setIn(['fundingDocuments', action.identifier, 'error'], false)
        .setIn(['fundingDocuments', action.identifier, 'files'], action.documents),
    ),
  [FUNDING_DOCUMENT_UPLOAD_FAILURE]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingDocuments', action.identifier, 'loading'], false)
        .setIn(['fundingDocuments', action.identifier, 'progress'], 0)
        .setIn(['fundingDocuments', action.identifier, 'success'], false)
        .setIn(['fundingDocuments', action.identifier, 'error'], action.error),
    ),
  [FUNDING_DOCUMENT_UPLOAD_PROGRESS]: (state, action) =>
    state.setIn(['fundingDocuments', action.identifier, 'progress'], action.progress),
});
